const selectors = {
  formWrapper: '[data-gift-card-form]',
  showFormToggle: '[data-show-form]',
};

function initCharacterCounter(formWrapper) {
  const messageTextarea = formWrapper.querySelector('[data-gift-message]');
  const charCountDisplay = formWrapper.querySelector('[data-char-count]');

  if (!messageTextarea || !charCountDisplay) {
    return;
  }

  const updateCharCount = () => {
    charCountDisplay.textContent = messageTextarea.value.length;
  };

  messageTextarea.addEventListener('input', updateCharCount);
  updateCharCount();
}

function toggleFormVisibility(formWrapper, showForm) {
  const recipientControlInput = formWrapper.querySelector(
    '[name="properties[__shopify_send_gift_card_to_recipient]"]',
  );

  if (showForm) {
    formWrapper.classList.remove('hidden');
    const requiredFields = formWrapper.querySelectorAll('[required]');
    requiredFields.forEach(field => {
      field.disabled = false;
    });
    if (recipientControlInput) {
      recipientControlInput.disabled = false;
    }
  } else {
    formWrapper.classList.add('hidden');
    const requiredFields = formWrapper.querySelectorAll('[required]');
    requiredFields.forEach(field => {
      field.disabled = true;
      field.value = '';
    });
    const messageField = formWrapper.querySelector('[data-gift-message]');
    if (messageField) {
      messageField.value = '';
    }
    if (recipientControlInput) {
      recipientControlInput.disabled = true;
    }
  }
}

function initFormToggle(formWrapper) {
  const toggleScope = formWrapper.closest('form') || formWrapper.parentElement;
  const toggleRadios =
    toggleScope?.querySelectorAll(selectors.showFormToggle) || [];

  if (!toggleRadios.length) {
    return;
  }

  toggleRadios.forEach(radio => {
    radio.addEventListener('change', e => {
      const shouldShow = e.target.value === 'true';
      toggleFormVisibility(formWrapper, shouldShow);
    });
  });
}

function setDateConstraints(dateInput) {
  if (!dateInput) {
    return;
  }

  const today = new Date();
  // 90 days from today is the maximum date allowed for a gift card
  const maxDate = new Date(today.getTime() + 90 * 24 * 60 * 60 * 1000);

  dateInput.min = today.toISOString().split('T')[0];
  dateInput.max = maxDate.toISOString().split('T')[0];
}

function toggleDatePicker(datePicker, dateInput, selectedValue) {
  if (selectedValue === 'date') {
    datePicker.classList.remove('hidden');
    if (dateInput) {
      dateInput.disabled = false;
    }
  } else {
    datePicker.classList.add('hidden');
    if (dateInput) {
      dateInput.disabled = true;
      dateInput.value = '';
    }
  }
}

function updateDateRequired(formWrapper, dateInput) {
  if (!dateInput) {
    return;
  }

  const dateRadio = formWrapper.querySelector(
    '[data-delivery-radio][value="date"]',
  );
  dateInput.required = dateRadio?.checked || false;
}

function initDeliveryOptions(formWrapper) {
  const deliveryRadios = formWrapper.querySelectorAll('[data-delivery-radio]');
  const datePicker = formWrapper.querySelector('[data-date-picker]');
  const dateInput = datePicker?.querySelector('input[type="date"]');

  if (!deliveryRadios.length || !datePicker) {
    return;
  }

  setDateConstraints(dateInput);

  if (dateInput) {
    dateInput.disabled = true;
  }

  deliveryRadios.forEach(radio => {
    radio.addEventListener('change', e => {
      toggleDatePicker(datePicker, dateInput, e.target.value);
      updateDateRequired(formWrapper, dateInput);
    });
  });
}

export default class GiftCardForm {
  constructor(container = document) {
    this.container = container;
    this.init();
  }

  init() {
    const giftCardFormWrappers = this.container.querySelectorAll(
      selectors.formWrapper,
    );

    giftCardFormWrappers.forEach(giftCardFormWrapper => {
      if (giftCardFormWrapper.dataset.initialized === 'true') {
        return;
      }

      giftCardFormWrapper.dataset.initialized = 'true';
      initFormToggle(giftCardFormWrapper);
      initCharacterCounter(giftCardFormWrapper);
      initDeliveryOptions(giftCardFormWrapper);
    });
  }
}
